import { initializeApp } from 'firebase/app'
import { getDatabase, ref, onValue, off, type DataSnapshot, type DatabaseReference } from 'firebase/database'

const firebaseConfig = {
  apiKey: 'AIzaSyDUvoO7oHuGo5-YUyV9ENkhgA5VGsERUtQ',
  authDomain: 'fastpass-c32df.firebaseapp.com',
  projectId: 'fastpass-c32df',
  storageBucket: 'fastpass-c32df.appspot.com',
  messagingSenderId: '387319832358',
  appId: '1:387319832358:web:01ffd06b1c57dd5cc2ebe7',
  measurementId: 'G-91G148YG9K',
  databaseURL: 'https://fastpass-c32df-default-rtdb.asia-southeast1.firebasedatabase.app/',
}

class FirebaseObserver {
  private readonly firebaseDB: ReturnType<typeof getDatabase>
  private listener: ((snapshot: DataSnapshot) => void) | null
  private firebaseRef: DatabaseReference | null

  constructor() {
    const app = initializeApp(firebaseConfig)
    this.firebaseDB = getDatabase(app)
    this.listener = null
    this.firebaseRef = null
  }

  subscribe(refUrl: string, onValueChange: (snapshot: DataSnapshot) => void) {
    this.unsubscribe()
    this.firebaseRef = ref(this.firebaseDB, refUrl)

    this.listener = (snapshot: DataSnapshot) => {
      onValueChange(snapshot)
    }

    onValue(this.firebaseRef, this.listener)
  }

  unsubscribe() {
    if (this.firebaseRef && this.listener) {
      off(this.firebaseRef, 'value', this.listener)
      this.listener = null
      this.firebaseRef = null
    }
  }
}

export const firebaseObserver = new FirebaseObserver()
